import { Link } from 'react-router-dom';
import { categories, aboutInfo } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">糖心视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              让每个人都能享受高清观影的乐趣。糖心视频，你的免费追剧首选平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">版权声明</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">帮助中心</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-accent-500"></i>
                {aboutInfo.contact.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-accent-500"></i>
                {aboutInfo.contact.phone}
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-accent-500 mt-0.5"></i>
                <span>{aboutInfo.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 糖心视频 TangXin Video. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            京ICP备2024000001号-1 | 京公网安备 11010502000001号
          </p>
        </div>
      </div>
    </footer>
  );
}